import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mdRender } from "../../functions/remarkable";
import DrillDownPlus from "./DrillDownPlus";
import MenuInsightQuestion from "./MenuInsightQuestion";
import MenuInsightsQuestionOffline from "./MenuInsights/MenuInsightsQuestionOffline.vue";
import StaffQuestion from "./StaffQuestion";
export default {
  name: 'FibQuizScreen',
  components: {
    'fib-drill-down-plus': DrillDownPlus,
    'fib-menu-insight-question': MenuInsightQuestion,
    'fib-staff-question': StaffQuestion,
    'fib-menu-insight-question-offline': MenuInsightsQuestionOffline
  },
  props: {
    screen: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      questions: []
    };
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    answers: function answers() {
      return this.$store.getters['answers/responses'] || {};
    },
    isApp: function isApp() {
      return this.$store.getters['config/isApp'];
    }
  },
  created: function created() {
    var _this = this;

    var screenQuestions = _toConsumableArray(this.screen.questions);

    this.questions = screenQuestions.map(function (q) {
      var obj = _objectSpread({}, q); // Check to see if any of the questions type equal the type 'fib-emoji'
      // Add the csat prop type to the objects before passing as questions


      if (obj.type === 'fib-emoji') {
        obj.props = _objectSpread(_objectSpread({}, obj.props), {}, {
          csat: true
        });
        return obj;
      } else if (obj.type === 'fib-menu-insight-question' && _this.isApp) {
        obj.type = 'fib-menu-insight-question-offline';
      } // if it isn't fib-emoji type then we just return the question unchanged


      return obj;
    });
  },
  mounted: function mounted() {
    // If the title is taller than the max-height defined - reduce the font-size until that's no
    // longer true. This code is very un-Vue as we don't set the font-size with some reactive
    // variable as that happens too slowly (having to pause in the while loop) to detect the
    // height changing.
    var titleRef = this.$refs.title;

    if (titleRef) {
      var MIN_FONT_SIZE = 12;
      var titleMaxHeight = this.getPropertyValueInPx(titleRef, 'max-height'); // Impose a lower bound on the font-size so that it remains readable & to ensure that this
      // loop terminates - this shouldn't really ever be reached, but if it is, the height likely
      // won't be below the max-height - but at the very least the title is still scrollable so
      // the content is still available.

      var fontSize = this.getPropertyValueInPx(titleRef, 'font-size');

      while (titleRef.scrollHeight >= titleMaxHeight && fontSize > MIN_FONT_SIZE) {
        fontSize--;
        titleRef.style.setProperty('font-size', "".concat(fontSize, "px"));
      }
    }
  },
  methods: {
    getPropertyValueInPx: function getPropertyValueInPx(ref, property) {
      var _window$getComputedSt, _window$getComputedSt2;

      return parseFloat((_window$getComputedSt = window.getComputedStyle(ref, null)) === null || _window$getComputedSt === void 0 ? void 0 : (_window$getComputedSt2 = _window$getComputedSt.getPropertyValue(property)) === null || _window$getComputedSt2 === void 0 ? void 0 : _window$getComputedSt2.replace('px', ''));
    },
    handleResponse: function handleResponse(value, question) {
      // PLEASE NOTE: Non-applicable responses will be stored as null - so ensure code elsewhere
      // interprets null as not a real value.
      this.$store.dispatch('answers/setResponse', {
        fromQuestion: true,
        meta: question._meta,
        value: question.type !== 'fib-select' ? value : value.label,
        id: question.id
      });
    },
    renderText: function renderText(text) {
      return mdRender(text);
    }
  }
};